/**
 * Creates a UUID using `Math.random`. Using `Math.random` is not considered safe.
 * However, SDK only uses it to generate the ID of the action requests which gets
 * deleted every action completion which only takes couple seconds. Hence, we should
 * not have to worry about collisions.
 */
export function uuid() {
  return 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx'.replaceAll('x', function (c) {
    const r = Math.trunc(Math.random() * 16),
      v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
